<script>
  export let attributes = {};
  export let selector = null;
  export let onMove = null;
  export let updateOnResize = false;

  const PADDING_TOP = 120;
  const PADDING_BOTTOM = 10;
  const PADDING_LEFT = 10;
  const PADDING_RIGHT = 10;

  const ZERO_MOVE = { movementX: 0, movementY: 0 };

  const between = (min, max, value) => Math.min(max, Math.max(value, min));

  const drags = draggable => {
    const moveable = selector ? document.querySelector(selector) : draggable;
    if (!moveable) return {};

    const parent = moveable.parentElement;
    const doc = document.documentElement;
    let isGrabbed = false;
    let [x, y] = [0, 0];

    const restrict = () => {
      const { clientHeight, clientWidth } = doc;
      const { height, width } = moveable.getBoundingClientRect();
      const { left, top } = parent.getBoundingClientRect();

      const maxX = clientWidth - left - width - PADDING_RIGHT;
      const maxY = clientHeight - top - height - PADDING_BOTTOM;
      const minX = -left + PADDING_LEFT;
      const minY = -top + PADDING_TOP;

      return [
        [minX, maxX],
        [minY, maxY],
      ];
    };

    const move = (e, update = false) => {
      if (!isGrabbed && !update) return;
      const { movementX: movedX, movementY: movedY } = e;
      x += movedX;
      y += movedY;

      const [[minX, maxX], [minY, maxY]] = restrict();
      const left = between(minX, maxX, x);
      const top = between(minY, maxY, y);
      moveable.style['left'] = `${left}px`;
      moveable.style['top'] = `${top}px`;
      if (onMove) onMove(e, moveable, left, top);
    };

    const update = () => move(ZERO_MOVE, true);
    const disable = () => (isGrabbed = false);
    const enable = () => {
      isGrabbed = true;
      x = moveable.offsetLeft;
      y = moveable.offsetTop;
    };

    if (updateOnResize) window.addEventListener('resize', update);
    draggable.addEventListener('mousedown', enable);
    window.addEventListener('mouseup', disable);
    window.addEventListener('mousemove', move);

    return {
      destroy() {
        if (updateOnResize) window.removeEventListener('resize', update);
        draggable.removeEventListener('mousedown', enable);
        window.removeEventListener('mouseup', disable);
        window.removeEventListener('mousemove', move);
      },
    };
  };
</script>

<div {...attributes} use:drags>
  <slot />
</div>

<style lang="scss">
  div {
    position: absolute;
    display: block;
    cursor: grab;
  }
</style>
